import { COLOR_ACCENT } from './blueprint-view-styles';

export type BlueprintExportOverlayProps = {
	current: number;
	total: number;
};

export const BlueprintExportOverlay = (props: BlueprintExportOverlayProps): React.ReactElement => {
	const { current, total } = props;
	const pct = total > 0 ? `${(current / total) * 100}%` : '0%';

	return (
		<div style={{
			position: 'absolute',
			inset: 0,
			zIndex: 100,
			backgroundColor: 'rgba(0, 0, 0, 0.5)',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '12px'
		}}>
			<div style={{ color: '#fff', fontSize: '14px', fontWeight: 600 }}>
				{total > 0 ? `Exporting page ${current + 1} of ${total}...` : 'Preparing export...'}
			</div>
			<div style={{
				width: '240px',
				height: '8px',
				backgroundColor: 'rgba(255, 255, 255, 0.25)',
				borderRadius: '4px',
				overflow: 'hidden'
			}}>
				<div style={{
					width: pct,
					height: '100%',
					backgroundColor: COLOR_ACCENT,
					borderRadius: '4px',
					transition: 'width 0.3s ease'
				}} />
			</div>
		</div>
	);
};
